/**
 * Created by DynamicDog on 2017-03-13.
 */
import {Component} from '@angular/core';
import {EtikettService} from "../services/etikett.service";

@Component({
    selector: 'busy-screen',
    template: `
            <div class="busy-screen" *ngIf="etikettService.isBusy()" (click)="onClick($event)" (scroll)="onClick($event)" style="text-align:center">
            <h1 style="margin-top:40%">{{'Var god vänta...'|translate}}</h1>
            <div style="display:inline-block">
                <!--md-progress-circle diameter="10" color="#ff00ff" mode="indeterminate" [value] = 50></md-progress-circle-->
            </div>
            </div>
        `,
})
export class BusyScreenComponent {
    constructor(private etikettService:EtikettService) {

    }

    public onClick(event):void {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }
}


// WEBPACK FOOTER //
// ./app/print/busyscreen.ts